import "./spinner.css";
import React from "react";

const Spinner = () => {
  return (
    <div className="spin_back">
      <p className="loading_spinner">Loading...</p>
    </div>
  );
};
export default Spinner;
